import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import "../css/terms.css";

export default function DataSecurity() {
  return (
    <>
      <Helmet>
        <title>Resumify | Data Security</title>
        <meta
          name="description"
          content="Learn how Resumify secures your personal information, protects user credentials, and maintains encrypted cloud storage."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="home-page">
        <Navbar />
        <main className="legal-container">
          <div className="legal-card">
            <h1>Data Security</h1>
            <p className="legal-date">Last updated: October 2026</p>

            <h2>1. Our Commitment to Security</h2>
            <p>
              Protecting your career history, personal contact info, and
              credentials is fundamental to what we do. We employ robust,
              industry-standard security measures to safeguard your information
              against unauthorized access, disclosure, or alteration.
            </p>

            <h2>2. Encryption in Transit & At Rest</h2>
            <p>
              All data transmitted between your browser and our servers is
              secured using modern TLS/HTTPS encryption protocols. CV records
              and account databases stored on our servers utilize robust
              encryption keys to protect data at rest.
            </p>

            <h2>3. Secure Authentication</h2>
            <p>
              We implement industry-standard password hashing algorithms and
              secure token-based session management to protect your user account
              from unauthorized access.
            </p>

            <h2>4. PCI-DSS Compliant Payments</h2>
            <p>
              All financial transactions are handled securely through Stripe.
              Stripe is certified as a PCI Level 1 Service Provider—the most
              stringent level of certification available in the payments
              industry. Resumify never touches or caches your raw debit/credit
              card details.
            </p>

            <h2>5. Infrastructure & Hosting</h2>
            <p>
              Our application is hosted on enterprise-grade cloud infrastructure
              featuring automated threat monitoring, firewall protection, and
              regular security patching.
            </p>

            <h2>6. Reporting Security Concerns</h2>
            <p>
              If you believe you have discovered a security vulnerability or bug
              within our platform, please report it directly to our engineering
              team at{" "}
              <a href="mailto:admin@resumify.co.uk">admin@resumify.co.uk</a>. We
              appreciate responsible disclosure.
            </p>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
